<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <freezer-form
      :isLoading="isLoading"
      :onSubmit="onSubmit">
    </freezer-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import FreezerForm from './FreezerForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { biobankRegistry } = services;
const { freezerService } = biobankRegistry;

export default {
  name: 'FreezerCreate',
  components: {
    FreezerForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Create Freezer',
      enableBackButton: true,
    },
  }),
  methods: {
    async onSubmit(data) {
      this.isLoading = true;
      try {
        const { _id: id } = await freezerService.create({ freezer: data });

        this.$snackbar.showOk({ text: 'Successfully created freezer!' });

        this.$router.replace({ name: 'freezer.view', params: { id } });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
